import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useSelector, useDispatch } from "react-redux";

import { getChat, initGetChat } from "../../Store/actions/index";
import Layout from "../../Hoc/Layout/Layout";
import Card from "../../Components/Chat/DealerCard";
import Chats from "../../Components/Chat/Chat";
import SendMessage from "../../Components/Chat/SendMessage";
import ChatLoader from "../../Components/Chat/ChatLoader";

export default function Chat() {
  const history = useHistory();
  const location = useLocation();

  const dispatch = useDispatch();

  const { user, currentUser } = useSelector((state) => state.Auth);

  const { chat, loading, error } = useSelector((state) => state.Chat);

  const chatId = location.state ? location.state.id : null;

  useEffect(() => {
    const token = localStorage.getItem("idToken");
    if (!token) history.push("/");
    else dispatch(initGetChat());
  }, [dispatch]);

  useEffect(() => {
    if (chatId && user) dispatch(getChat(chatId));
    else history.push("/");
  }, [chatId, user]);

  return (
    <Layout>
      {loading && <ChatLoader />}
      {!loading && chat && currentUser && (
        <div
          style={{
            boxShadow: "0 0 3px 1px #96969680",
            borderRadius: "11px",
            margin: "5rem 0",
          }}
        >
          <Card chat={chat.chat_participants} userId={currentUser.id} />
          <Chats
            chatMessages={chat.chat_messages}
            userId={currentUser.id}
            chatId={chat.id}
          />
          <SendMessage
            particpatntArr={chat.chat_participants}
            userId={currentUser.id}
            chatId={chat.id}
            chat={chat}
          />
        </div>
      )}
    </Layout>
  );
}
